<template>

  <ul
    class="list-group"
    v-if="intervideoInvites.length">
    <li 
      class="list-group-item" 
      v-for="(intervideoInvite, index) in intervideoInvites"
      :key="index">
        <a
          v-if="permissions.includes('manage_candidates') && intervideoInvite.status === 'pending'"
          style="float: right;"
          href="javascript:void(0)"
          @click="deleteIntervideoInvite(intervideoInvite._id)">
          <i class="fas fa-times" />
        </a>
        <Bullet
          :title="{ pending: 'Pendente', complete: 'Finalizado' }[intervideoInvite.status]"
          :status="{ pending: 'warning', complete: 'success' }[intervideoInvite.status]" />
        Vídeo entrevista
        <strong v-if="intervideoInvite.videoform_id">{{ intervideoInvite.videoform_id.name }}</strong>
        solicitada em {{ $d(new Date(intervideoInvite.created_at), 'short') }}
    </li>
  </ul>

</template>

<script>
import Bullet from '@/components/Parts/Bullet'

export default {
  name: 'CandidateIntervideoInviteList',
  components: {
    Bullet
  },
  props: [
  ],
  data () {
    return {
      creating: false,
      loading: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    onlyThisJob () {
      return this.$store.getters.getCandidateOnlyThisJob
    },
    intervideoInvites () {
      return this.$store.getters.getIntervideoInvites
    }
  },
  watch: {
    'selectedJob._id': function (val) {
      this.loadData(1)
    },
    onlyThisJob: function (val) {
      this.loadData(1)
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
  },
  methods: {
    loadData () {
      this.loading = true

      let params = {
        candidate_id: this.candidate._id,
        sort: '-created_at'
      }

      if (this.selectedJob && this.onlyThisJob) {
        params.job_id = this.selectedJob._id
      }

      this.$store
      .dispatch('selectIntervideoInvites', params)
      .then((response) => {
        this.loading = false
      })
    },
    deleteIntervideoInvite (id) {
      const deleteAction = () => {
        this.loading = true

        return this.$store
        .dispatch('deleteIntervideoInvite', id)
        .then((response) => {
          this.loading = false
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Intervideo/CandidateIntervideoInviteList.vue